<div class="divUpload">
  <label for="file-upload" class="lblUpload">Change</label>
  <input id="file-upload" type="file" (change)="uploadFiles($event)" placeholder="Upload your profile picture"
         [(ngModel)]="fileUpload" style="display: none;"
         accept="image/jpeg, image/png"/>
</div>
